import React, { useCallback, useEffect, useState, forwardRef } from 'react';
import Grid from '@mui/joy/Grid';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';


///////////////////////Components
import FAQComponent from '../../Components/FAQ/FAQComponent';

import AddIconImage from '../../assets/icons/Add-icon.svg'


///////////////////// Modal
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import Textarea from '@mui/joy/Textarea';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';



//////////////////// API
import { getQuestions, createQuestions, getQuestionsDtails, UpdateQuestionsDtails } from '../../Api/FAQ';


const schema = yup.object({
    title_ar: yup.string().required("هذا الحقل مطلوب"),
    title_en: yup.string().required("هذا الحقل مطلوب"),
    answer_ar: yup.string().required("هذا الحقل مطلوب"),
    answer_en: yup.string().required("هذا الحقل مطلوب"),

})



const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function FAQPage() {
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [listQuestions, setListQuestions] = useState([]);
    const [actionTypeFqa, setActionTypeFqa] = useState(null);
    const [questionId, setQuestionId] = useState(null);
    
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            title_ar: "",
            title_en: "",
            answer_ar: "",
            answer_en: ""
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState




    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const getListQuestions = useCallback(async () => {
        const res = await getQuestions();
        if (res) {
            setListQuestions(res)
        }
    }, []);

    const submitNewQuestion = async (data) => {
        setLoading(true)
        if(actionTypeFqa == 'edit') {
            try {
                const res = await UpdateQuestionsDtails(questionId, data)
                if (res) {
                    setOpenAlert(true)
                    setMessageAlert("تم تعديل سؤال بنجاح")
                    setLoading(false)
                    setOpen(false)
                    setValue('title_ar', null)
                    setValue('title_en', null)
                    setValue('answer_ar', null)
                    setValue('answer_en', null)
                    setQuestionId(null)
                    setActionTypeFqa(null)
                    getListQuestions();
                }
            } catch (error) {
                if (error.response) {
                    setLoading(false)
                    setOpen(false)
                    setOpenAlertError(true)
                    setMessageAlertError(error.response.data.message)
                    setValue('title_ar', null)
                    setValue('title_en', null)
                    setValue('answer_ar', null)
                    setValue('answer_en', null)
                    setQuestionId(null)
                    setActionTypeFqa(null)
                }
            }
        }else {
            try {
                const res = await createQuestions(data)
                if (res) {
                    setOpenAlert(true)
                    setMessageAlert("تم اضافة سؤال جديد بنجاح")
                    setLoading(false)
                    setOpen(false)
                    getListQuestions();
                }
            } catch (error) {
                if (error.response) {
                    setLoading(false)
                    setOpen(false)
                    setOpenAlertError(true)
                    setMessageAlertError(error.response.data.message)
                }
            }
        }
    }

    const actionEdit = async (id, actionType) => {
        setQuestionId(id)
        setActionTypeFqa(actionType)
        const res = await getQuestionsDtails(id)
        if(res){
            setValue('title_ar', res.title_ar)
            setValue('title_en', res.title_en)
            setValue('answer_ar', res.answer_ar)
            setValue('answer_en', res.answer_en)
        }
        setOpen(true)
    }

    useEffect(() => {
        getListQuestions();
    }, [getListQuestions])

    return (
        <>

            {/* Alert Meesage */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            {/* Modal Create */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <ModalDialog sx={{ overflowY: 'scroll' }}>
                    <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold', marginBottom: '30px' }}>إضافة سؤال جديد</DialogTitle>
                    <form
                        onSubmit={handleSubmit(submitNewQuestion)}
                    >
                        <Stack spacing={2} sx={{ width: '500px', height: 'auto', overflowY: 'scroll', direction:'rtl' }}>
                            <FormControl>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>السؤال</FormLabel>
                                <Input
                                    autoFocus placeholder='ادخل السؤال هنا.....'
                                    sx={{ height: '60px', borderRadius: '30px' }}
                                    {...register('title_ar')}
                                />
                            </FormControl>
                            {errors.title_ar &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.title_ar?.message}</Typography>
                            }
                            <FormControl sx={{ direction: 'ltr' }}>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>Question</FormLabel>
                                <Input
                                    autoFocus
                                    placeholder='Enter your question here.....'
                                    sx={{ height: '60px', borderRadius: '30px' }}
                                    {...register('title_en')}
                                />
                            </FormControl>
                            {errors.title_en &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.title_en?.message}</Typography>
                            }
                            <FormControl>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>إجابة السؤال </FormLabel>
                                <Textarea
                                    placeholder="ادخل إجابة السؤال هنا....."
                                    minRows={3}
                                    sx={{
                                        '--Textarea-focusedInset': 'var(--any, )',
                                        '--Textarea-focusedThickness': '0.25rem',
                                        '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                                        '&::before': {
                                            transition: 'box-shadow .15s ease-in-out',
                                        },
                                        '&:focus-within': {
                                            borderColor: '#86b7fe',
                                        },
                                        borderRadius: '30px'
                                    }}
                                    {...register('answer_ar')}
                                />
                            </FormControl>
                            {errors.answer_ar &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.answer_ar?.message}</Typography>
                            }
                            <FormControl sx={{direction:'ltr'}}>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>question answer</FormLabel>
                                <Textarea
                                    placeholder="question answer ....."
                                    minRows={3}
                                    sx={{
                                        '--Textarea-focusedInset': 'var(--any, )',
                                        '--Textarea-focusedThickness': '0.25rem',
                                        '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                                        '&::before': {
                                            transition: 'box-shadow .15s ease-in-out',
                                        },
                                        '&:focus-within': {
                                            borderColor: '#86b7fe',
                                        },
                                        borderRadius: '30px'
                                    }}
                                    {...register('answer_en')}
                                />
                            </FormControl>
                            {errors.answer_en &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.answer_en?.message}</Typography>
                            }
                            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '40px' }}>
                                <Button loading={loading} type="submit" sx={{ borderRadius: '15px', backgroundColor: '#3E64F4', height: '60px', width: '170px', marginLeft: '20px' }}> {actionTypeFqa == 'edit' ? "تعديل" : "اضافة السؤال"}</Button>
                                <Button type="button" onClick={() => setOpen(false)} sx={{ borderRadius: '15px', backgroundColor: '#757778', height: '60px', width: '170px' }}>الغاء</Button>
                            </Box>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>


            <Box sx={{ backgroundColor: '#F7F9FB' }}>
                <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    sx={{ width: '100%', padding: '50px 2%' }}
                >
                    <Grid xs={6}>
                        <Typography level="h2" fontSize="xl" sx={{ mb: 0.5 }}>
                            الأسئلة الشائعة
                        </Typography>
                    </Grid>
                    <Grid xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={() => setOpen(true)} startDecorator={<img src={AddIconImage} className='imgIconButton' alt='icon add' />}>إضافة سؤال جديد</Button>
                    </Grid>
                </Grid>

                <FAQComponent 
                    listQuestions={listQuestions} 
                    getListQuestions={getListQuestions} 
                    actionEdit={actionEdit}
                />
            </Box>
        </>
    )
}